import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Typography,
  notification,
  Menu,
  Input,
  Dropdown,
  Modal
} from "antd";

import { SearchOutlined , DownOutlined } from "@ant-design/icons";

// Images
import { getVehiclesTypes, getVehiclesTypeDetail, deleteVehiclesType } from "../api/vehicles-type.service";
import { useEffect, useState } from "react";
import AddVehicleTypeFormModal from "../components/forms/vehicletypes/AddVehicleTypeFormModal";
import EditVehicleTypeFormModal from "../components/forms/vehicletypes/EditVehicleTypeFormModal";

const { Title } = Typography

function VehiclesType() {

  const handleConfirm = async (id) => {
    try {
      const data = await deleteVehiclesType(id);
      
        notification.success({ message: 'Category deleted successfully' });
        fetchVehicles();
      
    } catch (err) {
      notification.error({ message: 'Failed to delete category' });
    }
  }

  const getVehicleDataDelete = async (id) => {
    Modal.confirm({
      title: "Warning",
      content: "Are you sure you want to delete this?",
      okText: "Confirm",
      cancelText: "Cancel",
      onOk() {
          handleConfirm(id)
      },
      onCancel() {
          console.log("Cancelled");
      },
  });
  }

  const getColumnSearchProps = (dataIndex, placeholder, renderField) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${placeholder}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const recordValue = renderField ? renderField(record) : record[dataIndex];
      return recordValue
        ? recordValue.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
  });
  
  const columns = [
    {
      title: "VEHICLE TYPE",
      dataIndex: "name",
      key: "name",
      width: "25%",
      ...getColumnSearchProps("name", "Vehicle Type", (record) => record.name),
      render: (text, record) => (
        <div className="avatar-info">
          <Title level={5}>{record.name}</Title>
        </div>
      ),
    },
    {
      title: "BASE PRICE (PKR)",
      dataIndex: "basePricePKR",
      key: "basePricePKR",
      width: "25%",
      sorter: (a, b) => a.basePricePKR - b.basePricePKR,
      render: (text, record) => (
        <div className="avatar-info">
          <Title level={5}>{record.basePricePKR}</Title>
        </div>
      ),
    },
    {
      title: "PER MINUTE PRICE (PKR)",
      dataIndex: "perMinutePricePKR",
      key: "perMinutePricePKR",
      width: "25%",
      sorter: (a, b) => a.perMinutePricePKR - b.perMinutePricePKR,
      render: (text, record) => (
        <div className="avatar-info">
          <Title level={5}>{record.perMinutePricePKR}</Title>
        </div>
      ),
    },
    {
      title: "PER DAY PRICE (PKR)",
      dataIndex: "perDayPricePKR",
      key: "perDayPricePKR",
      width: "25%",
      sorter: (a, b) => a.perDayPricePKR - b.perDayPricePKR,
      render: (text, record) => (
        <div className="avatar-info">
          <Title level={5}>{record.perDayPricePKR}</Title>
        </div>
      ),
    },
    {
      title: "ACTIONS",
      width: "25%",
      render: (text, record) => {
        const menu = (
          <Menu>
            <Menu.Item
              key="view"
              onClick={() => getVehicleData(record.id, true)}
            >
              View
            </Menu.Item>
            <Menu.Item key="edit" onClick={() => getVehicleData(record.id)}>
              Edit
            </Menu.Item>
            <Menu.Item key="delete" onClick={() => getVehicleDataDelete(record.id)}>
              Delete
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu}>
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              Tasks <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [vehicleData, setVehicleData] = useState(null);
  const [isViewOnly ,setisViewOnly] = useState(false);

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const data = await getVehiclesTypes();
      setVehicles(data?.data || []); // Set the fetched vehicles data
    } catch (err) {
      notification.error({ message: 'Failed to fetch vehicles' });
      setError('Failed to fetch vehicles');
    } finally {
      setLoading(false);
    }
  };

  const getVehicleData = async (id, isViewOnly=false) => {
    setisViewOnly(isViewOnly)
    const data = await getVehiclesTypeDetail(id);
    setVehicleData(data.data);
    setIsModalOpenEdit(true);
  }

  useEffect(() => {
    fetchVehicles();
  }, []);

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOkEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleCancelEdit = () => {
    setIsModalOpenEdit(false);
  };

  return (
    <>
      {vehicleData && <EditVehicleTypeFormModal isViewOnly={isViewOnly} vehicleData={vehicleData} fetchVehicles={fetchVehicles} handleCancel={handleCancelEdit} handleOk={handleOkEdit} isModalOpen={isModalOpenEdit} setIsModalOpen={setIsModalOpenEdit} />}
      <AddVehicleTypeFormModal fetchVehicles={fetchVehicles} handleCancel={handleCancel} handleOk={handleOk} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <div className="mb-3 flex justify-end">
        <Button type="primary" onClick={showModal}>
          Add Category / Pricing
        </Button>
      </div>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Category / Pricing Table"
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={vehicles}
                  pagination={{
                    pageSize: 100
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default VehiclesType;
